export const defaultRuntimeStatuses = ['Completed', 'Running', 'Pending'];

export const defaultTimeRange = { span: 'day' };
